import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
  };
};

const getJsonHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };
};

// PAYMENT DUE NORMAL

// INSERT
export const insertPaymentDue = (payload) => {
  return customerApi.post("/insertPaymentDue", payload, {
    headers: getJsonHeaders(),
  });
};

// LIST
export const getPaymentDueList = (payload) => {
  return customerApi.post("/getPaymentDueList", payload, {
    headers: getAuthHeaders(),
  });
};

// DETAIL
export const getPaymentDueDetail = (payload) => {
  return customerApi.post("/getPaymentDueDetail", payload, {
    headers: getAuthHeaders(),
  });
};

// UPDATE
export const updatePaymentDue = (payload) => {
  return customerApi.post("/updatePaymentDue", payload, {
    headers: getJsonHeaders(),
  });
};

// DELETE
export const deletePaymentDue = (payload) => {
  return customerApi.post("/deletePaymentDue", payload, {
    headers: getAuthHeaders(),
  });
};

// PAYMENT DUE DEMO

// INSERT
export const insertPaymentDueDemo = (payload) => {
  return customerApi.post("/insertPaymentDueDemo", payload, {
    headers: getJsonHeaders(),
  });
};

// LIST
export const getPaymentDueDemoList = (payload) => {
  return customerApi.post("/getPaymentDueDemoList", payload, {
    headers: getAuthHeaders(),
  });
};

// DETAIL
export const getPaymentDueDemoDetail = (id) => {
  return customerApi.get(`/getPaymentDueDemoDetail/${id}`, {
    headers: getAuthHeaders(),
  });
};

// UPDATE
export const updatePaymentDueDemo = (payload) => {
  return customerApi.post("/updatePaymentDueDemo", payload, {
    headers: getJsonHeaders(),
  });
};

// DELETE
export const deletePaymentDueDemo = (payload) => {
  return customerApi.post("/deletePaymentDueDemo", payload, {
    headers: getJsonHeaders(),
  });
};
